import './styles.scss'
import React, { useState, useEffect } from 'react'
import { Container } from 'reactstrap'
import { I18n } from 'react-redux-i18n'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'

import { company, apiSchedules } from '../../api'
import * as delegationActions from '../../redux/actions/delegations'
import * as brandsActions from '../../redux/actions/brands'
import EditFloat from './EditFloat'
import WrapperBrands from './WrapperBrands'
import ModalBrand from './ModalBrand'
import ModalDelegation from './ModalDelegation'
import ModalPlan from 'components/ModalPlan'
import ScheduleModal from 'components/ScheduleModal'
import { canAddBrand, canAddDelegation } from 'services/PlanRestrictions'
import Nixi1Spinner from 'components/Nixi1Spinner'

const OrganizationView = (props) => {
  const companies = useSelector(state => state.companies)
  const currentPlan = useSelector(state => state.currentPlan)

  const dispatch = useDispatch()
  const history = useHistory()
  const [loading, setLoading] = useState(true)
  const [modalBrand, setModalBrand] = useState(false)
  const [currentBrand, setCurrentBrand] = useState({})
  const [currentDelegation, setCurrentDelegation] = useState({})
  const [modalDelegation, setModalDelegation] = useState(false)
  const [currentCompany, setCurrentCompany] = useState({})
  const [brands, setBrands] = useState({})
  const [delegations, setDelegations] = useState({})
  const [schedulesType, setSchedulesType] = useState({})
  const [schedules, setSchedules] = useState({})
  const [showPlanModal, setShowPlanModal] = useState(false)
  const [isOpenBusinessSchedule, setIsOpenBusinessSchedule] = useState(false)

  const onTogglePlanModal = () => setShowPlanModal(!showPlanModal)
  const toggleBusinessSchedule = () => setIsOpenBusinessSchedule(!isOpenBusinessSchedule)

  useEffect(() => {
    getCompany()
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (Object.keys(schedulesType).length) getSchedules({ group: schedulesType.group, createdTo: schedulesType.createdTo })
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [schedulesType])

  const getCompany = async () => {
    const _company = await company.companies.get(companies)
    setCurrentCompany(_company.data.results)
    const _brands = await company.brands.getBrands({ idCompany: companies._id })
    setBrands(_brands.data.results)
    const _delegations = await company.delegations.getDelegations({ idCompany: companies._id })
    setDelegations(_delegations.data.results)
    setLoading(false)
  }

  const getSchedules = ({ group, createdTo }) => {
    const tag = schedulesType.tag === 'office' ? 'outOfOffice' : schedulesType.tag
    apiSchedules.get({ tag: [tag], group: [group], createdTo: [createdTo] })
      .then(result => setSchedules({ [tag]: result[0] }))
      .finally(() => toggleBusinessSchedule())
  }

  const editCompany = () => {
    const url = props.match.url
    history.push(`${url}/${companies._id}`)
  }

  const openBrandModal = (brand) => {
    if (brand) {
      setCurrentBrand(brand)
    } else {
      setCurrentBrand({})
      setCurrentDelegation({})
    }

    // actualizar marca
    if (brand?._id) {
      setModalBrand(!modalBrand)

      return
    }

    // Nueva marca
    if (canAddBrand(currentPlan, Object.keys(brands).length)) {
      setModalBrand(!modalBrand)
    } else {
      onTogglePlanModal()
    }
  }

  const openDelegationModal = (delegation, brand) => {
    if (delegation) {
      setCurrentDelegation(delegation)
    } else {
      setCurrentBrand(brand)
      setCurrentDelegation({})
    }

    // actualizar delegación
    if (delegation?._id) {
      setModalDelegation(!modalDelegation)

      return
    }

    // Nueva delegación
    if (canAddDelegation(currentPlan, Object.keys(delegations).length)) {
      setModalDelegation(!modalDelegation)
    } else {
      onTogglePlanModal()
    }
  }

  const removeDelegation = async (delegation) => {
    await dispatch(delegationActions.deleteDelegation(delegation))
    dispatch(delegationActions.getDelegations({ idCompany: companies._id }))
    setCurrentBrand({})
    setCurrentDelegation({})
    getCompany()
    setModalDelegation(!modalDelegation)
  }

  const removeBrand = async (brand) => {
    await dispatch(brandsActions.deleteBrand(brand))
    dispatch(delegationActions.getDelegations({ idCompany: companies._id }))
    dispatch(brandsActions.getBrands({ idCompany: companies._id }))
    setCurrentBrand({})
    setCurrentDelegation({})
    getCompany()
    setModalBrand(!modalBrand)
  }

  const handleSaveSchedule = ({ schedule, group, data }) => {
    return apiSchedules.post({
      schedules: [{ ...schedule, group, schedule: data }]
    })
      .then(result => setSchedules({ [schedule.tag]: result[0] }))
  }

  return (
    <div className='animated fadeIn'>
      <Container id={'companyManagement'} fluid className='py-5 company-management'>
        <div className='title-container'>
          <div className='title'>
            <div style={{ marginRight: '12px' }}>{I18n.t('dashboard_organization')}</div>
            <EditFloat isEdit editAction={editCompany} />
          </div>
          <div className='company-name'>{companies.name}</div>
        </div>
        {
          loading
            ? <Nixi1Spinner width='30px' height='30px' />
            : (
              <WrapperBrands
                openBrandModal={openBrandModal}
                openDelegationModal={openDelegationModal}
                setSchedulesType={setSchedulesType}
                company={currentCompany}
                brands={brands}
                delegations={delegations}
              />
            )
        }
      </Container>
      <ModalBrand
        isOpen={modalBrand}
        toggle={() => setModalBrand(!modalBrand)}
        currentBrand={currentBrand}
        removeBrand={removeBrand}
        getCompany={getCompany}
      />
      <ModalDelegation
        isOpen={modalDelegation}
        toggle={() => setModalDelegation(!modalDelegation)}
        currentDelegation={currentDelegation}
        currentBrand={currentBrand}
        removeDelegation={removeDelegation}
        getCompany={getCompany}
      />
      <ModalPlan
        isOpen={showPlanModal}
        toggle={onTogglePlanModal}
      />
      {isOpenBusinessSchedule && Object.keys(schedules).length && (
        <div className='modal-background'>
          <ScheduleModal
            scheduleMode={schedulesType.tag}
            closeModal={toggleBusinessSchedule}
            schedules={[schedules[schedulesType.tag === 'office' ? 'outOfOffice' : schedulesType.tag].schedule]}
            saveSchedules={data => handleSaveSchedule({
              schedule: schedules[schedulesType.tag === 'office' ? 'outOfOffice' : schedulesType.tag],
              group: schedulesType.group,
              data
            })}
            outOfOfficeEnableHolidays
            outOfOfficeEnableEveryDay
          />
        </div>
      )}
    </div>
  )
}

export default OrganizationView
